import { useEffect } from 'react';

export const useAnalytics = () => {
    useEffect(() => {
        if (window.gtag) {
            // Track initial page view
            window.gtag('event', 'page_view', {
                page_title: document.title,
                page_location: window.location.href,
                page_path: window.location.pathname + window.location.search,
            });

            // Track when user leaves the page
            const handleBeforeUnload = () => {
                window.gtag('event', 'page_exit', {
                    page_title: document.title,
                    time_on_page: Math.round((Date.now() - performance.timing.navigationStart) / 1000),
                });
            };

            window.addEventListener('beforeunload', handleBeforeUnload);
            return () => window.removeEventListener('beforeunload', handleBeforeUnload);
        }
    }, []);
};

export const trackEvent = (category, action, label, value = null) => {
    if (window.gtag) {
        const eventData = {
            event_category: category,
            event_label: label,
            send_to: 'G-KSL5XMVZVE'  // Add your GA4 measurement ID
        };

        // Handle both numeric values and object values
        if (typeof value === 'number') {
            eventData.value = value;
        } else if (typeof value === 'object' && value !== null) {
            Object.assign(eventData, value);
        }

        window.gtag('event', action, eventData);

        // Debug log in development
        if (process.env.NODE_ENV === 'development') {
            console.log('Analytics Event:', { category, action, label, value });
        }
    }
}; 